export enum ImportLicenseRequiredEnum {
  NEVER = "NEVER",
  ALWAYS = "ALWAYS",
  ON_RESTRICTION_EXCEEDED = "ON_RESTRICTION_EXCEEDED",
}
